import React from "react";
import NodataGif from "../../../resources/images/no-data-found.gif"
const  NoDataFond= () => {
  return (
    <>
       <div className="no-data-container">
         <h6 className="no-data-found">No Data Found</h6>
      </div>
    <div className="empty-state">
      <div className="empty-state__content">
        <div style={{width:'100%',height:'50vh',flexDirection: 'column'}} className="empty-state__icon_notFound">
          <img
            src={NodataGif}
            alt=""
          />
          {/* <h1>No Data</h1> */}
        </div>
      </div>
    </div>
    </>
  );
};
export default NoDataFond;